var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paragraph-container"},[_c('div',{staticClass:"title"},[_c('heading',{attrs:{"tag":"h4"}},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"paragraph"},[_c('paragraph',[_vm._v(_vm._s(_vm.paragraph))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }